import { cn } from '@theprintbar/shared';
import clsx from 'clsx';

interface PillProps extends React.HTMLAttributes<HTMLDivElement> {
	className?: string;
	children: React.ReactNode;
}

export function Pill({ className, children, ...props }: PillProps) {
	return (
		<div
			className={cn('rounded-full border border-blue px-3 py-[5px] flex items-center capitalize w-fit text-xs', className)}
			{...props}
		>
			{children}
		</div>
	);
}
